import React, { useState, useEffect, useCallback } from "react";
import {
  getCustomerLottery,
  updateCustomerLotteryStatus,
  getCustomerLotteryDetail,
  exportCustomerLotteryExcel,
} from "../../api/customerLotteryApi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../CustomerManagement/style.css";

const MySwal = withReactContent(Swal);

const RewardCodeDetailModal = ({ isOpen, onClose, details }) => {
  if (!isOpen || !details) return null;
  const formatDate = (ts) => {
    if (!ts) return "";
    const d = new Date(Number(ts));
    if (isNaN(d.getTime())) return ts;
    return d.toLocaleString();
  };
  // Helper: always return array
  const toArray = (val) => {
    if (Array.isArray(val)) return val;
    if (val && typeof val === "object") {
      // Nếu là object có key số, chuyển thành array theo thứ tự key
      const keys = Object.keys(val);
      if (keys.every((k) => !isNaN(Number(k)))) {
        return keys.sort((a, b) => Number(a) - Number(b)).map((k) => val[k]);
      }
      return Object.values(val);
    }
    return [];
  };
  // Log dữ liệu share_links để debug
  console.log(
    "share_links:",
    details.share_links,
    toArray(details.share_links)
  );
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 800 }}
      >
        <div className="modal-header">
          <h2>{details.username || details.code || "Chi tiết"}</h2>
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          {/* Link chia sẻ - moved to top */}
          <div className="detail-section">
            <b>Link chia sẻ:</b>{" "}
            {toArray(details.history_code?.share_links).length > 0
              ? toArray(details.history_code?.share_links).map(
                  (l, idx, arr) => (
                    <span key={idx}>
                      <a href={l} target="_blank" rel="noopener noreferrer">
                        Link {idx + 1}
                      </a>
                      {idx < arr.length - 1 ? " | " : ""}
                    </span>
                  )
                )
              : "Không có dữ liệu"}
          </div>
          <br />
          {/* Lịch sử đổi code */}
          <div className="detail-section">
            <b>Lịch sử đổi code:</b>
            <table
              className="ip-login-table"
              style={{ marginTop: 4, width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Giftcode</th>
                  <th>Thời gian đổi</th>
                </tr>
              </thead>
              <tbody>
                {toArray(details.history_code?.giftcode_trade).length > 0 ? (
                  toArray(details.history_code?.giftcode_trade).map(
                    (g, idx) => (
                      <tr key={idx}>
                        <td>{g.giftcode}</td>
                        <td>{formatDate(g.traded_at)}</td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={2}>Không có dữ liệu</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <br />
          {/* Chi tiết mã dự thưởng */}
          <div className="detail-section">
            <b>Mã may mắn:</b>
            <table
              className="ip-login-table"
              style={{ marginTop: 4, width: "100%" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "25%" }}>Mã dự thưởng</th>
                  <th style={{ width: "25%" }}>Mã dự thưởng</th>
                  <th style={{ width: "20%" }}>Loại quay số</th>
                  <th style={{ width: "30%" }}>Thời gian nhận</th>
                </tr>
              </thead>
              <tbody>
                {toArray(details.history_code?.code_details).length > 0 ? (
                  toArray(details.history_code?.code_details).map((cd, idx) => (
                    <tr key={idx}>
                      <td style={{ width: "25%" }}>{cd.event_code_detail}</td>
                      <td style={{ width: "25%" }}>
                        {toArray(cd.code).length > 0
                          ? toArray(cd.code).join(", ")
                          : "Không có"}
                      </td>
                      <td style={{ width: "25%" }}>
                        {toArray(cd.type_code).length > 0
                          ? toArray(cd.type_code).join(", ")
                          : ""}
                      </td>
                      <td style={{ width: "25%" }}>
                        {formatDate(cd.claimed_at)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3}>Không có dữ liệu</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <br />
          {/* IP đăng nhập - chuyển xuống cuối */}
          <div className="detail-section">
            <b>IP đăng nhập gần nhất:</b>
            <table
              className="ip-login-table"
              style={{ marginTop: 4, width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Địa chỉ IP</th>
                  <th>Thời gian</th>
                </tr>
              </thead>
              <tbody>
                {toArray(details.ip_login).length > 0 ? (
                  toArray(details.ip_login).map((ip, idx) => (
                    <tr key={idx}>
                      <td>{ip.ip_address}</td>
                      <td>{formatDate(ip.timestamp)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2}>Không có dữ liệu</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const SITE = process.env.REACT_APP_SITE_ID || "78win";

const RewardCodePage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({ username: "", from: "", to: "" });
  const [detailModal, setDetailModal] = useState({ isOpen: false, data: null });
  const [exporting, setExporting] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.page,
        pageSize: pagination.pageSize,
        username: filters.username || undefined,
        from_date: filters.from
          ? new Date(filters.from).toISOString().slice(0, 19)
          : undefined,
        to_date: filters.to
          ? new Date(filters.to).toISOString().slice(0, 19)
          : undefined,
      };
      const response = await getCustomerLottery(params);
      setData(response.data?.items || []);
      setPagination((prev) => ({ ...prev, total: response.data?.total || 0 }));
    } catch (err) {
      MySwal.fire("Lỗi!", "Không thể tải danh sách mã dự thưởng.", "error");
    } finally {
      setLoading(false);
    }
  }, [
    pagination.page,
    pagination.pageSize,
    filters.username,
    filters.from,
    filters.to,
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setPagination((p) => ({ ...p, page: 1 }));
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateStatus = async (item) => {
    MySwal.fire({
      title: "Xác nhận",
      text: `Bạn có chắc muốn thay đổi trạng thái của "${
        item.username || item.code
      }"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Đồng ý",
      cancelButtonText: "Hủy",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await updateCustomerLotteryStatus(item._id);
          setData((prev) =>
            prev.map((c) =>
              c._id === item._id ? { ...c, status: !c.status } : c
            )
          );
          MySwal.fire("Thành công!", "Trạng thái đã được cập nhật.", "success");
        } catch (err) {
          if (err.response && err.response.status === 403) {
            MySwal.fire(
              "Truy cập bị từ chối",
              "Bạn không có quyền thực hiện chức năng này.",
              "error"
            );
          } else {
            MySwal.fire("Lỗi!", "Cập nhật trạng thái thất bại.", "error");
          }
        }
      }
    });
  };

  const handleViewDetails = async (item) => {
    try {
      const response = await getCustomerLotteryDetail(item._id);
      setDetailModal({ isOpen: true, data: response.data });
    } catch (err) {
      MySwal.fire("Lỗi!", "Không thể lấy chi tiết.", "error");
    }
  };

  const handleExportExcel = async () => {
    try {
      const res = await exportCustomerLotteryExcel(SITE);
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `ma_du_thuong-${SITE}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      MySwal.fire("Lỗi!", "Xuất file Excel thất bại.", "error");
    }
  };

  const totalPages = Math.ceil(pagination.total / pagination.pageSize);

  return (
    <>
      <div className="users-header">
        <div className="header-content">
          <h3>Quản lý mã dự thưởng</h3>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", flex: 1 }}>
          <button
            style={{
              background: "#28a745",
              color: "white",
              borderRadius: 6,
              padding: "10px 16px",
              fontSize: "1rem",
              border: "none",
              cursor: "pointer",
              minWidth: 120,
              fontWeight: 500,
            }}
            onClick={handleExportExcel}
            disabled={exporting}
          >
            {exporting ? "Đang xuất..." : "Xuất File"}
          </button>
        </div>
      </div>
      <div className="table-controls">
        <input
          type="text"
          name="username"
          placeholder="Tìm theo tài khoản..."
          className="search-input"
          value={filters.username}
          onChange={handleFilterChange}
        />
        <input
          type="datetime-local"
          name="from"
          className="search-input"
          value={filters.from}
          onChange={handleFilterChange}
          style={{ marginLeft: 8 }}
          placeholder="Từ ngày"
        />
        <input
          type="datetime-local"
          name="to"
          className="search-input"
          value={filters.to}
          onChange={handleFilterChange}
          style={{ marginLeft: 8 }}
          placeholder="Đến ngày"
        />
      </div>
      <div className="users-table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Số mã đã nhận</th>
              <th>Trạng thái</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="table-message">
                  Đang tải...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan="4" className="table-message">
                  Không tìm thấy dữ liệu.
                </td>
              </tr>
            ) : (
              data.map((item) => (
                <tr key={item._id}>
                  <td>{item.username}</td>
                  <td>{item.history_code?.total_code}</td>
                  <td>
                    <button
                      className={`status-toggle-btn ${
                        item.status ? "status-active" : "status-inactive"
                      }`}
                      onClick={() => handleUpdateStatus(item)}
                    >
                      {item.status ? "Hoạt động" : "Đang khóa"}
                    </button>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn"
                        title="Xem chi tiết"
                        onClick={() => handleViewDetails(item)}
                      >
                        👁️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination-container">
        <div className="pagination-summary">
          Trang <strong>{pagination.page}</strong> /{" "}
          <strong>{totalPages}</strong> (Tổng: {pagination.total})
        </div>
        <div className="pagination-controls">
          <button
            onClick={() => setPagination((p) => ({ ...p, page: p.page - 1 }))}
            disabled={pagination.page <= 1}
          >
            Trước
          </button>
          <button
            onClick={() => setPagination((p) => ({ ...p, page: p.page + 1 }))}
            disabled={pagination.page >= totalPages}
          >
            Sau
          </button>
        </div>
      </div>
      <RewardCodeDetailModal
        isOpen={detailModal.isOpen}
        onClose={() => setDetailModal({ isOpen: false, data: null })}
        details={detailModal.data}
      />
    </>
  );
};

export default RewardCodePage;
